import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import { service, actions } from "./data";
import { withMasked, withApiResult, withCrud } from "~/hocs";
import { defaultRequestFilters, REQUEST_PAYLOAD_FILTER } from "./data/service";
import { preventBubbleUp } from "~/admin/utils";
import * as model from "./data/model";
// Components
import AddEditPanel from "./add-edit/add-edit-container";
import ActiveInactiveLink from "../component/active-inactive-link";
import { DataTable, DialogBox, DialogBoxFooterType, Button } from "~/core";
import HierarchyFilter from "../component/hierarchy-filter";
import SearchPerson from "../component/search-person";
import { messages } from "../i18n-messages";
import SlidingPanel from "~/sliding-panel/sliding-panel";
// user import/export specifics
import { PROPS_SETUP_USER_IMPORT_EXPORT } from "~/admin/setup/user-role/data/model";
import { currentUserHasRole } from "~/login/selectors";
import ImportExportHeader from "~/admin/agBytes/components/import-export-header";
import { connect } from "react-redux";

export class User_ extends Component {
    static propTypes = {
        actions: PropTypes.object,
        addEditPanel: PropTypes.object,
        closeSidePanel: PropTypes.func,
        deleteSelected: PropTypes.func,
        hasImportExportPermission: PropTypes.bool,
        hierarchy: PropTypes.object,
        intl: intlShape.isRequired,
        needs: PropTypes.func,
        onSubmit: PropTypes.func,
        openAddEditPanel: PropTypes.func,
        records: PropTypes.array,
        toggleActiveInactive: PropTypes.func,
        userRole: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            isCreate: false,
            searchValue: "",
            personAddMode: false,
        };
    }

    onToggleModalClick = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    toggleActiveInactive = () => {
        this.setState(
            {
                showInactive: !this.state.showInactive,
            },
            () => {
                this.props.toggleActiveInactive();
            }
        );
    };

    onFilterChange = (data) => {
        const { needs, actions } = this.props;
        const requestOptions = {
            ...defaultRequestFilters,
            [REQUEST_PAYLOAD_FILTER]: {
                ...defaultRequestFilters[REQUEST_PAYLOAD_FILTER],
                [model.PROPS_ORG_LEVEL_GUID]: data ? data.orgLevelGuid : null,
            },
        };
        needs([actions.fetch(requestOptions)]);
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.records !== this.props.records) {
            this.setState({
                records: nextProps.records,
            });
        }
    }

    onCreate = () => {
        this.setState({ isCreate: false, personAddMode: true }, () => {
            const { modelName, mode, recordGuid, recordName } = this.state;
            this.props.openAddEditPanel(modelName, mode, recordGuid, recordName);
        });
    };

    openDialogBox = (modelName, mode, recordGuid, recordName) => {
        this.setState(
            {
                isCreate: mode === "ADD",
                modelName,
                mode,
                recordGuid,
                recordName,
            },
            () => {
                const { isCreate, mode, recordGuid, recordName, modelName } = this.state;
                !isCreate && this.props.openAddEditPanel(modelName, mode, recordGuid, recordName);
            }
        );
    };

    onPersonSelection = (recordGuid) => {
        this.setState({ isCreate: false, recordGuid, mode: "EDIT", personAddMode: true }, () => {
            const { modelName, mode, recordGuid, recordName } = this.state;
            this.props.openAddEditPanel(modelName, mode, recordGuid, recordName);
        });
    };

    deleteSelected = (options) => {
        let { selectedItems } = options;
        selectedItems = selectedItems[0];
        this.props.records.forEach((record) => {
            if (record[model.PROPS_PERSON_GUID] === selectedItems) {
                selectedItems = record[model.PROPS_USER_GUID];
            }
        });
        options = { ...options, selectedItems };
        this.props.deleteSelected(options);
    };

    render() {
        const { formatMessage } = this.props.intl;
        const { showAddEditPanel } = this.props.addEditPanel;
        const { isCreate, searchValue, personAddMode } = this.state;
        let slidingPanelProps = { ...this.props, searchValue, personAddMode };
        if (showAddEditPanel) {
            slidingPanelProps = {
                ...slidingPanelProps,
                ...this.props.addEditPanel,
            };
        }
        return (
            <div className="content-table-container">
                {this.props.hasImportExportPermission ? (
                    <ImportExportHeader
                        {...this.props}
                        service={service}
                        hideActiveRecordLink
                        onlyImportExportOptions
                    />
                ) : null}
                <div className="filter-header-container">
                    <div className="filter-container">
                        <HierarchyFilter onFilterChange={this.onFilterChange} />
                    </div>
                    {!this.props.userRole[model.PROPS_ACTIVE_INACTIVE] ? null : (
                        <div className="active-inactive-container">
                            <ActiveInactiveLink toggleActiveInactive={this.toggleActiveInactive} />
                        </div>
                    )}
                </div>
                <DataTable
                    {...this.props}
                    isEditable
                    isCheckbox={this.props.hasImportExportPermission}
                    service={service}
                    messages={messages}
                    openAddEditPanel={this.openDialogBox}
                    records={this.props.records}
                    deleteSelected={this.deleteSelected}
                />
                {!showAddEditPanel ? null : (
                    <form onSubmit={(event) => preventBubbleUp(event)}>
                        <SlidingPanel
                            {...slidingPanelProps}
                            close={this.props.closeSidePanel}
                            component={AddEditPanel}
                            navigateTo={{
                                parentNameCode: "101",
                                childNameCode: "120",
                            }}
                        >
                            <Button type="save" forceSubmit onClick={() => this.props.onSubmit()} />
                            <Button
                                type="cancel"
                                className="user-cancel"
                                onClick={() => {
                                    this.props.closeSidePanel();
                                    this.setState({ personAddMode: false });
                                }}
                            />
                        </SlidingPanel>
                    </form>
                )}
                {isCreate && (
                    <DialogBox
                        forceOverflow
                        title={formatMessage(messages.selectPerson)}
                        footerType={DialogBoxFooterType.NONE}
                        isOpen={isCreate}
                        isModal={isCreate}
                        onClose={() => this.setState({ isCreate: false })}
                    >
                        <SearchPerson
                            autoFocus
                            openOnFocus={false}
                            onCreate={this.onCreate}
                            onSelection={this.onPersonSelection}
                            onSearchChange={(value) => this.setState({ searchValue: value })}
                        />
                    </DialogBox>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    hasImportExportPermission: currentUserHasRole(state, PROPS_SETUP_USER_IMPORT_EXPORT),
});

export const User = injectIntl(
    withMasked(
        withApiResult(
            withCrud(connect(mapStateToProps)(User_), service, actions),
            actions.importData
        )
    )
);
